import React, { useState, useEffect } from "react";
import { Container, Col, Row, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../commons/inFormTypes";
import Loaders from "../components/Loaders";
import { zoomIn } from "react-animations";
import Radium, { StyleRoot } from "radium";

function Request() {
  const [seenFile, setSeenFile] = useState([]);
  const [load, setLoad] = useState(true);
  const userToken = localStorage.getItem("user_token");
  const navigate = useNavigate();

  const styles = {
    zoomIn: {
      animation: "x 1s",
      animationName: Radium.keyframes(zoomIn, "zoomIn"),
    },
  };

  var FormData = require('form-data');
  var data = new FormData();


  useEffect(() => {
    const axios = require("axios");
    setLoad(false);
    axios({
      method: "post",
      url: apiUrl + "my-list",
      headers: {
        'Access-Control-Allow-Origin': "*",
        Accept: "application/json",
        Authorization: "Bearer " + userToken,
      },
      data: data,
    }).then((res) => {
      setLoad(true);
      if (res.data.success && res.data.result) {
        setSeenFile(res.data.result);
      } else {
      }
    });
  }, []);


  const cardHandler = (Id) => {
    navigate(`/admin/follow/${Id}`, { replace: false });
  };



  return (
    <div>
      <Container>
        <StyleRoot>
          <div className="test" style={styles.zoomIn}>

            <Row className="justify-content-center justify-content-lg-start pt-5">
              {seenFile.map((data, index) => {
                return (
                  <Col xs={10} lg={4} className="rgc-title">
                    <Card className="rgc-follow-card">
                      <Card.Header className="rgc-follow-header">
                        <i className='fas fa-bell'></i>
                        <div>کد پیگیری:</div>
                        &nbsp;<div>{data.tracking_code}</div>
                      </Card.Header>
                      <Card.Body>

                        <Row className="justify-content-md-start justify-content-center">
                          <Col xs={10} className="rgc-follow-item">عنوان:&nbsp; {data.title} </Col>
                          <Col xs={10} className="rgc-follow-item">تاریخ:&nbsp; {data.date}</Col>
                        </Row>

                        <Button className="float-start rgc-follow-btn m-2"
                          onClick={() => cardHandler(data.tracking_code)}
                        > پیگیری </Button>
                      </Card.Body>
                    </Card>
                    {/* <Table striped bordered hover responsive className="rgc-table">
                        <thead>
                          <tr>
                           <th>عنوان </th>
                           <th>کد پیگیری</th>
                           <th>تاریخ</th>
                           <th>عملیات</th>
                          </tr>
                        </thead>
                        <tbody>
                        {seenFile.map((data, index) => {
                              return (
                                <tr key={index}>
                                <td>{data.title}</td>
                                <td>{data.tracking_code}</td>
                                <td>{data.date}</td>
                                <td>
                                <Button variant="primary"
                                 onClick={() => cardHandler(data.tracking_code)}
                                > پیگیری </Button>
                                </td>
                              </tr>
                              )
                            })
                          }
                        </tbody>
                      </Table> */}
                  </Col>
                )
              })}
            </Row>


          </div>
        </StyleRoot>
      </Container>
      <Loaders loads={load} />
    </div>
  );
}

export default Request;
